import {
    SetClientNewNotificationsStateHandler
} from '../../gameClient/clientCommands/SetClientNewNotificationsStateHandler';
import { GameClient } from '../../gameClient/gameClient';
import { NotificationsWrap } from '../../general/modules/notifications/NotificationsWrap';
import { WebpushServiceApi } from '../../general/modules/notifications/WebpushServiceApi';

type TrySetNewWebPushSaveDataType = {
    isAccessPush: boolean
}

export class SetNotificationsStateHandler {
    // eslint-disable-next-line class-methods-use-this
    public handle(request: TrySetNewWebPushSaveDataType): void {
        this.setNotificationState(request.isAccessPush);
    }

    private async setNotificationState(state: boolean): Promise<void> {
        try {
            let completed: boolean;
            if (state) {
                if (!NotificationsWrap.hasBrowserGrantedPushes()) {
                    console.error('Browser has disabled web-push notifications');
                    GameClient.getInstance().sendCommand(new SetClientNewNotificationsStateHandler({
                        isSuccess: false
                    }));
                    return;
                }

                const hasRegistration = await WebpushServiceApi.isAccountExists();
                if (!hasRegistration) {
                    await WebpushServiceApi.saveUserToken('provider');
                } else {
                    await WebpushServiceApi.setAccountState(state);
                }

                completed = await NotificationsWrap.registerForProviderExternally();
            } else {
                completed = await NotificationsWrap.unregisterFromWebPush();
            }
            GameClient.getInstance().sendCommand(new SetClientNewNotificationsStateHandler({
                isSuccess: completed
            }));
        } catch (exception) {
            GameClient.getInstance().sendCommand(new SetClientNewNotificationsStateHandler({
                isSuccess: false
            }));
            console.error('Provider fault on setNotificationState', exception);
            window.Sentry.captureException(exception);
        }
    }
}
